/* eslint-disable no-underscore-dangle */
import {
  selectSelectedRound,
  setLoadedRound,
  setSelectedRound,
} from 'redux/features/round-slice';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import {useLazyQuery} from '@apollo/client';
import {GET_NUMBER_OF_ROUNDS} from 'packages/graphql/v2/queries';
import ErrorBoundary from 'packages/common-ui/ErrorBoundary';
import useAppSelector from 'packages/hooks/use-app-selector';
import Select from 'react-select';
import {selectTournament} from 'redux/features/app-slice';
import Skeleton from '@material-ui/lab/Skeleton';
import {useEffect} from 'react';

type Vars = {
  tournamentId: string;
};
type Data = {
  getNumberOfRounds: number;
};

const RoundsSelect = () => {
  const dispatch = useAppDispatch();
  const selectedTournament = useAppSelector(selectTournament);
  const selectedRound = useAppSelector(selectSelectedRound);
  const [getRounds, {data, loading, error}] = useLazyQuery<Data, Vars>(
    GET_NUMBER_OF_ROUNDS
  );

  useEffect(() => {
    if (selectedTournament) {
      getRounds({
        variables: {
          tournamentId: selectedTournament?._id,
        },
      });
    }
    if (data && selectedRound.value === -1) {
      dispatch(setLoadedRound(null));
    }
  }, [selectedTournament, getRounds, dispatch, data, selectedRound.value]);

  const handleChange = (value: any) => {
    dispatch(setSelectedRound(value));
  };

  if (loading) return <Skeleton height={56} />;
  if (error) return <ErrorBoundary error={error} />;
  if (!selectedTournament) return null;

  const rounds: any = data && [
    ...new Array(data?.getNumberOfRounds).fill(0).map((_, i) => {
      return {
        label: `Ronda ${i + 1}`,
        value: i,
      };
    }),
    {label: 'Ronda Actual', value: -1},
  ];

  return (
    <>
      <Select
        placeholder="Seleciona una ronda a administrar"
        isLoading={loading}
        value={selectedRound}
        options={rounds}
        getOptionValue={(option) => option.value}
        onChange={handleChange}
      />
    </>
  );
};

export default RoundsSelect;
